import { render, staticRenderFns } from "./LoopBox.vue?vue&type=template&id=37a8a815&scoped=true&"
import script from "./LoopBox.vue?vue&type=script&lang=js&"
export * from "./LoopBox.vue?vue&type=script&lang=js&"
import style0 from "./LoopBox.vue?vue&type=style&index=0&id=37a8a815&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a8a815",
  null
  
)

export default component.exports